import { BalancingActSimulationType } from './types';

export const getBalancingActContentTitleFromType = (
  type: BalancingActSimulationType,
  isPb: boolean
): string => {
  if (isPb) {
    return 'Prioritization';
  }

  switch (type) {
    case BalancingActSimulationType.BUDGET:
      return 'Budget Simulation';
    case BalancingActSimulationType.HOUSING:
      return 'Housing Simulation';
    case BalancingActSimulationType.RECEIPT:
      return 'Taxpayer Receipt';
    default:
      return 'Prioritization';
  }
};
